import React from "react";

const UserProfile = ({ name, fallbackImageUrl }) => {
    const getInitials = (fullName) => {
        if (!fullName || typeof fullName !== "string") return null;

        const nameParts = fullName.trim().split(" ");
        const firstInitial = nameParts[0]?.charAt(0).toUpperCase() || "";
        const lastInitial = nameParts[1]?.charAt(0).toUpperCase() || "";

        return `${firstInitial}${lastInitial}`;
    };

    const initials = getInitials(name);

    return (
        <div className="tw-w-10 tw-h-10 max-sm:tw-w-8 max-sm:tw-h-8 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-bg-[#208177] tw-text-white tw-font-bold tw-text-[12px]">
            {initials && !fallbackImageUrl ? (
                initials
            ) : (
                <img src={fallbackImageUrl} alt="Default Profile" className="tw-w-full tw-h-full tw-object-cover tw-rounded-full" />
            )}
        </div>
    );
};

export default UserProfile;
